export const SUPPORTED_LANGUAGES = {
  en: {
    name: "English",
    code: "en",
    locale: "en-US",
    muiLocale: "enUS",
  },
  ar: {
    name: "العربية",
    code: "ar",
    locale: "ar-EG",
    muiLocale: "arEG",
  },
} as const;

export const SUPPORTED_LANGUAGE_CODES = ["en", "ar"] as const;

export default SUPPORTED_LANGUAGES;
